import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import moment from 'moment'

Vue.use(VueI18n)

const messages = {
  de: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Elemente pro Seite:',
        rowsPerPageAll: 'Alle',
        pageText: '{0}-{1} von {2}',
        noResultsText: 'Keine Elemente gefunden',
        nextPage: 'Nächste Seite',
        prevPage: 'Vorherige Seite'
      },
      dataTable: {
        rowsPerPageText: 'Zeilen pro Seite:'
      },
      noDataText: 'Keine Daten vorhanden'
    },
    ValidationRules: {
      isRequired: 'Benötigtes Feld',
      isValidPassword: 'Kein gültiges Passwort',
      isPasswordMatch: 'Muss übereinstimmen',
      isMinEightChars: 'Min. 8 Zeichen',
      isValidEmail: 'Keine gültige E-Mail'
    }
  },
  en: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Items per page:',
        rowsPerPageAll: 'All',
        pageText: '{0}-{1} of {2}',
        noResultsText: 'No matching records found',
        nextPage: 'Next page',
        prevPage: 'Previous page'
      },
      dataTable: {
        rowsPerPageText: 'Rows per page:'
      },
      noDataText: 'No data available'
    },
    ValidationRules: {
      isRequired: 'Required field',
      isValidPassword: 'No valid password',
      isPasswordMatch: 'Must match',
      isMinEightChars: 'Min. 8 chars',
      isValidEmail: 'No valid E-Mail'
    }
  },
  tr: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Sayfa başına gösterim:',
        rowsPerPageAll: 'Tümü',
        pageText: '{0}-{1} / {2}',
        noResultsText: 'Eşeleşen kayıt bulunamadı',
        nextPage: 'Sonraki sayfa',
        prevPage: 'Önceki sayfa'
      },
      dataTable: {
        rowsPerPageText: 'Sayfa başı satır sayısı:'
      },
      noDataText: 'Gösterilecek veri yok'
    },
    ValidationRules: {
      isRequired: 'Zorunlu alan',
      isValidPassword: 'En az 8 karakter',
      isPasswordMatch: 'Şifrelerin uyuşması gerekmektedir'
    }
  },
  ru: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Записей на странице:',
        rowsPerPageAll: 'Все',
        pageText: '{0}-{1} из {2}',
        noResultsText: 'Не найдено подходящих записей',
        nextPage: 'Следующая страница',
        prevPage: 'Предыдущая страница'
      },
      dataTable: {
        rowsPerPageText: 'Строк на странице:'
      },
      noDataText: 'Отсутствуют данные'
    },
    ValidationRules: {
      isRequired: 'Обязательное поле',
      isValidPassword: 'Невалидный пароль',
      isPasswordMatch: 'Парои должны совпадать',
      isMinEightChars: 'Мин. 8 символов',
      isValidEmail: 'Невалидная эл. почта'
    }
  }
}

export const i18n = new VueI18n({
  locale: 'de',
  messages
})

export function setI18nLanguage (lang) {
  localStorage.locale = lang
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  moment.locale(lang)
}
